var _rect, _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirtel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 56",
    role: "img",
    "aria-label": "Airtel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 56,
    rx: 12,
    fill: "#e40000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 35c9-1 15-7 18-18 8 5 16 7 28 7-8 10-21 15-38 15z",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 47,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#fff"
  }, "airtel")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtel);
export default __webpack_public_path__ + "static/media/airtel.285df4764559a2219aa02839525bfcb6.svg";
export { ForwardRef as ReactComponent };